import { Controller } from "@hotwired/stimulus"

// Live show/hide of department-scoped fields on the client edit form:
// brand-management-only sections (Instagram/TikTok passwords, content
// cadence, Brand Voice) and the playlisting-only Playlisting Budget card.
// An admin toggles the department checkbox and those fields appear or
// disappear immediately. Nothing is deleted, the fields just hide.
// Non-admins have no checkboxes, so their sections keep the visibility the
// server rendered from the stored flags.
//
// It also arms the billing-date field's `required` attribute (SPT-67),
// because that arming depends on the same visibility this controller owns.
export default class extends Controller {
  static targets = ["brandField", "brandToggle", "playlistField", "playlistToggle",
                    "budget", "resetDay"]

  connect() {
    this.sync()
  }

  sync() {
    if (this.hasBrandToggleTarget) {
      const brandOn = this.brandToggleTarget.checked
      this.brandFieldTargets.forEach((el) => el.classList.toggle("hidden", !brandOn))
    }
    if (this.hasPlaylistToggleTarget) {
      const playOn = this.playlistToggleTarget.checked
      this.playlistFieldTargets.forEach((el) => el.classList.toggle("hidden", !playOn))
    }
    this.armResetDay()
  }

  // A billing date is owed only when there is a budget to bill against.
  // Both halves of the condition are load-bearing:
  //
  //   visible - `required` on a display:none input makes Chromium refuse the
  //     submit with an unfocusable-control console error: no bubble, no
  //     focus, no flash, nothing the operator can see. The budget card is
  //     CSS-hidden for non-playlisting clients but ALWAYS submits, so a
  //     static `required` in the ERB would silently brick Save on every
  //     PR-only and BM-only client in the roster. We read the `hidden` class
  //     this controller itself toggles rather than offsetParent: no layout
  //     flush, no race with stylesheet load, and it fails closed.
  //   budget non-blank - a blank budget means DELETE the stored row, which
  //     must stay a legal submit.
  //
  // Note it does NOT read the Playlisting checkbox: that checkbox renders for
  // bmt_admin only, so a senior_staff editor has no toggle in the DOM and a
  // toggle-derived condition would silently never arm for the very people who
  // fill these in.
  armResetDay() {
    if (!this.hasResetDayTarget || !this.hasBudgetTarget) return
    const visible = this.resetDayTarget.closest(".hidden") === null
    this.resetDayTarget.required = visible && this.budgetTarget.value.trim() !== ""
  }
}
